import { useTheme } from '@shopify/polaris-viz-core';
import { PREVIEW_ICON_SIZE } from '../../../../constants.js';
import { TITLE_MARGIN } from '../../constants.js';
import styles from './TooltipRow.scss.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SeriesIcon } from '../../../shared/SeriesIcon/SeriesIcon.js';
import { TrendIndicator } from '../../../TrendIndicator/TrendIndicator.js';

function TooltipRow({
  color,
  isComparison = false,
  label,
  renderSeriesIcon,
  shape,
  trend,
  value
}) {
  var _renderSeriesIcon;
  const selectedTheme = useTheme();
  return /*#__PURE__*/jsxs("div", {
    className: styles.Row,
    children: [color != null && /*#__PURE__*/jsx("div", {
      style: {
        width: PREVIEW_ICON_SIZE
      },
      children: (_renderSeriesIcon = renderSeriesIcon === null || renderSeriesIcon === void 0 ? void 0 : renderSeriesIcon()) !== null && _renderSeriesIcon !== void 0 ? _renderSeriesIcon : /*#__PURE__*/jsx(SeriesIcon, {
        color: color,
        shape: shape,
        lineStyle: isComparison ? 'dotted' : 'solid'
      })
    }), /*#__PURE__*/jsx("span", {
      className: styles.Truncate,
      style: {
        color: selectedTheme.tooltip.textColor,
        marginRight: TITLE_MARGIN
      },
      children: label
    }), /*#__PURE__*/jsx("span", {
      className: styles.Value,
      style: {
        color: selectedTheme.tooltip.textColor
      },
      children: value
    }), trend != null && /*#__PURE__*/jsx("div", {
      className: styles.Trend,
      children: /*#__PURE__*/jsx(TrendIndicator, {
        ...trend
      })
    })]
  });
}

export { TooltipRow };
